export enum ReduxActionType {
    SetCounter,
    IncrementCounter,
    SetCurrentTagCollection,
    SetCurrentModule,
    SetCurrentModuleData,
}
